import SharedManagementAvailability from "views/Asesorias/components/ManagementAvailability/ManagementAvailability";
import {
    requestCreateInactivity,
    requestRestoreInactivity
} from "services/employability";

const ManagementAvailability = props => (
    <SharedManagementAvailability
        {...props}
        slotLabel="turno"
        slotDemonstrative="este"
        switchAvailability={({ activatedHour, inactivity, dateTimeData }) =>
            activatedHour
                ? requestRestoreInactivity(inactivity.id)
                : requestCreateInactivity({
                    ...dateTimeData,
                    reason: "Otras actividades"
                })}/>
);

export default ManagementAvailability;
